import { render } from "./Manuals.vue?vue&type=template&id=1e656306&scoped=true"
import script from "./Manuals.vue?vue&type=script&lang=js"
export * from "./Manuals.vue?vue&type=script&lang=js"

import "./Manuals.vue?vue&type=style&index=0&id=1e656306&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e656306"]])

export default __exports__